import { RouterProvider } from 'react-router-dom';
import { QueryProvider } from '@/providers/query-provider';
import { ThemeProvider } from '@/providers/theme-provider';
import { AuthProvider } from '@/providers/auth-provider';
import { router } from '@/router';
import { PWAAutoUpdater } from '@/components/pwa-auto-updater';
import { DynamicImportErrorBoundary } from '@/components/dynamic-import-error-boundary';
import { useChunkErrorHandler } from '@/hooks/use-chunk-error-handler';
import { usePreventZoom } from '@/hooks/use-prevent-zoom';
import { usePageTracking } from '@/hooks/useAnalytics';
import { useHeartbeat } from '@/hooks/useHeartbeat';
import { DeviceAwareWrapper } from '@/components/device-aware-wrapper';
import { CookieBanner } from '@/components/cookie-banner';

function App() {
  // Handle chunk loading errors globally
  useChunkErrorHandler();

  // Prevent zooming in the PWA
  usePreventZoom();

  // Auto-track page views
  usePageTracking();

  // Send heartbeat to GlitchTip for uptime monitoring
  useHeartbeat();

  return (
    <>
      <DynamicImportErrorBoundary>
        <ThemeProvider>
          <DeviceAwareWrapper excludePaths={['/legal', '/terms', '/privacy']}>
            <QueryProvider>
              <AuthProvider>
                <RouterProvider router={router} />
                <PWAAutoUpdater />
                {/* Toaster moved to main.tsx outside error boundaries */}
              </AuthProvider>
            </QueryProvider>
          </DeviceAwareWrapper>
        </ThemeProvider>
        {/* Cookie Banner: Shows only on first visit (LSSI Art. 22.2 compliance) */}
        <CookieBanner />
      </DynamicImportErrorBoundary>
    </>
  );
}

export default App;
